import React from 'react'
import Ad from './Ad'

export const ContentWrapper = ({ content, pageType, isAdBlock }) => {
  return (
    <div>
      <div id="custom-nav" data-id={pageType}></div>
      <Ad id="banner" className="react-ad ad-slot-banner ad-wrapper" slotType="banner" data-slot-type="banner" data-slot-kvps="pos=banner" isAdBlock={isAdBlock} />
      <section id="main-container">
        {content}
      </section>   
    </div>
  )
}

export default ContentWrapper



// WEBPACK FOOTER //
// ../app/components/common/ContentWrapper.jsx